import { Text } from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../../i18n';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { parseStringForAnswers } from '../../../../utils/stringUtils';

interface Props {
  question: FlowsQuestion;
}

const FlowsBoxQuestionDescription: React.FC<Props> = ({ question }) => {
  const answers = useFlowsSelector((state) => state.flows.answers);
  const translatedText = handleResponseLanguage(question.description);

  return (
    <Text
      mt="2"
      textStyle="smallBody"
      color="gray.400"
      mb={{ base: 4, laptop: 0 }}
      whiteSpace="pre-wrap"
      dangerouslySetInnerHTML={{
        __html: parseStringForAnswers({
          answers,
          question: translatedText,
          bold: true,
          index: question.index,
        }),
      }}
    />
  );
};

export default FlowsBoxQuestionDescription;
